import Alert from 'utils/Alert/Alert';
import {PhoneNumberForm, WaitingForPayment} from 'components/Checkouts/Checkout/common';
import {usePayWithPalmpay, STEPS} from './PayWithPalmpayProvider';
import TransactionStatus from 'components/Checkouts/Checkout/common/TransactionStatus';

export const PayWithPalmpay = () => {
    const context = usePayWithPalmpay();
    const {currentState, errorMsg, setErrorMsg, updateCurrentState} = context;

    const render = () => {
        switch (currentState) {
            case STEPS.PHONE_VERIFICATION:
            default:
                return <PhoneNumberForm context={context} />;

            case STEPS.WAITING_FOR_PAYMENT:
                return <WaitingForPayment />;

            case STEPS.FAILED:
                return (
                    <div className="py-4">
                        <TransactionStatus
                            isError
                            title="Transaction Failed or Expired"
                            btnName="Retry"
                            handleClick={() => updateCurrentState(STEPS.PHONE_VERIFICATION)}
                            message={
                                <span>
                                    No payment received for this transaction. <br />
                                    Contact <b>support@blusalt.net</b> on any issue related to this
                                    transaction.
                                </span>
                            }
                        />
                    </div>
                );
        }
    };
    return (
        <>
            {errorMsg && <Alert {...errorMsg} onClose={() => setErrorMsg()} />}
            {render()}
        </>
    );
};
